const translations = {
  en: {
    "LOADING" : "Loading...",
    "Inicio": "Home",
    "Sobre Nosotros": "About Us",
    "Vender Monedas": "Sell Coins",
    "OFERTA": "Offer Available!",
    "COMPRA": "BUY",
    "LLEVATE": "TAKE",
    "PEDIDO": "Place your Order",
    "LLEVATE2": "Take",
    "LLEVATE3": "to get a GIFT",
    "BONUS": "to get a",
    "INTERESTED": "I'm Interested",
    "REGALO": "as a gift!",
    "COMO": "HOW TO BUY?",
    "PASO1": "Place your order. Choose your currency, platform, and amount of coins. You will be redirected to our Whatsapp.",
    "PASO2": "After confirming the payment, you must buy the card we will indicate you (it doesn't matter if you don't have coins).",
    "PASO3": "You will list the player with the specifications that we will indicate to you and you will send us a photo, so we can find the card on the market and send you the coins through his auction.",
    "PASO4": "Done!",
    "PAGO": "Payment Methods",
    "BOOSTING": "BOOSTING",
    "RANGO": "We achieve that range that is difficult for you to reach",

    "faq1": "How does the transfer method work?",
    "answer1": "We use the bidding method. It consists of listing a card for sale on the transfer market, and we will buy it at a high price so that the coins reach your account.",
    
    "faq2": "Is there a risk of my account being banned?",
    "answer2": "With our years of experience, we have developed a transfer method along with recommended measures to follow, ensuring a secure transaction. Our priority is always the customer and the security of their account.",
    
    "faq3": "What payment methods do you offer?",
    "answer3": "We offer various payment methods for each country so you can pay in your local currency. To see the available options, you can check the homepage of our website, where most of them are listed, or ask us directly on WhatsApp!",
    
    "faq4": "Is this safe?",
    "answer4": "We have been selling coins since FIFA 18. We have completed over 9,000 sales, and every year we deliver nearly 1 billion coins. If you still have doubts, you can also check our 7+ highlighted stories of 'Customers' on our Instagram, where we have 15k+ followers and showcase just some of our sales!",
    
    "faq5": "Do you also sell players?",
    "answer5": "Yes and no. We don’t sell players directly, but we do sell the amount of coins you need to buy the player you want or complete the SBC you’re aiming for. In other words, you can buy coins and then use them to sign the player you’re looking for.",
    
    "faq6": "Why are coins better than FIFA Points?",
    "answer6": "It’s simple. They are up to 5 times cheaper, and you can do much more with them compared to FIFA Points. With FIFA Points, you can only open packs, meaning you depend on luck. With coins, you can directly buy the players you want, open packs, or use them however you prefer. With the same amount of money spent on FC Points, you can open three times as many packs with coins.",
    
    "faq7": "How long does it take to receive my coins?",
    "answer7": "Simple! It only takes the duration of the bid. Once you make the purchase, you’ll receive the coins in your account within an hour.",
    
    "faq8": "Do you cover the EA Tax and the coins I spend on the transfer?",
    "answer8": "Of course! We want the number of coins you buy to be the amount you receive (often with a little bonus 😉). We cover the 5% EA Tax and the coins you spend on the transfer card, so if you buy 100,000 coins, you will receive 100,000 coins in your account. You won’t lose a single coin!",
    
    "faq9": "Do I need to have coins to start the transfer?",
    "answer9": "No, you don’t need to have coins to start the transfer. We will use very cheap cards or ones you already have in your club.",
    
    "faq10": "Do I have to provide my account details or any personal information?",
    "answer10": "No, we will never ask for any personal details or account information.",
    
    "faq11": "I’m not at my console. Can I do it from the Companion App?",
    "answer11": "Yes, you can complete the transfer safely and easily from the Companion App. You can do it from anywhere.",
    
    "faq12": "What is the FUT Boosting service, and is it safe?",
    "answer12": "Yes, the customer is ALWAYS our priority. We work with professional and trusted players who have been with us for years. Through our system, your data will NEVER be shared and will remain secure. Once the service is completed, all information related to your account will be deleted, ensuring that only you have access to it again.",
    
    
    "faqTitle" : "Frequently Asked Questions",
    "showMore": "Show More",
    "showLess" : "Show Less",
    "buy" : "BUY",
    "sellCoinsTittle" : "Sell Coins",
    "sellCoins" : "To start selling your coins, please contact us through WhatsApp.",
    "aboutUs" : "About Us",
    "reason1": "+9.000 sales made",
    "reason2": "+12 years of experience",
    "reason3": "+3.800 satisfied customers",
    "reason4": "+2600 Millon coins delivered",
    "paso" : "STEP"
},
  es: {
      "LOADING" : "Cargando...",
      "Inicio": "Inicio",
      "Sobre Nosotros": "Sobre Nosotros",
      "Vender Monedas": "Vender Monedas",
      "OFERTA": "¡Oferta Disponible!",
      "COMPRA": "COMPRA",
      "LLEVATE": "LLEVA",
      "PEDIDO": "Haz tu Pedido",
      "LLEVATE2": "Llevate",
      "LLEVATE3": "para un REGALO",
      "BONUS": "para obtener un",
      "INTERESTED": "Estoy Interesado",
      "REGALO": "de regalo!",
      "COMO": "¿CÓMO COMPRAR?",
      "PASO1": "Haz tu pedido. Selecciona tu moneda, la plataforma en la que juegas y la cantidad de monedas que buscas, y serás redirigido a nuestro chat de Whatsapp.",
      "PASO2": "Tras confirmar el pago, deberás comprar la carta que te indiquemos (no importa si no tienes monedas).",
      "PASO3": "Publicarás el jugador con las especificaciones que te indiquemos, y nos enviarás una foto para poder encontrarlo en el mercado y enviarte las monedas mediante su puja.",
      "PASO4": "¡Listo!",
      "PAGO": "Métodos de Pago",
      "BOOSTING": "Servicio de Boosting",
      "RANGO": "Conseguimos ese rango al que te cuesta llegar",

      "faq1": "¿Cómo es el método de traspaso?",
      "answer1": "Utilizamos el método de puja. Consiste en poner una carta a la venta en el mercado de transferibles, y nosotros te la compraremos a un precio elevado para que te lleguen las monedas.",
      "faq2": "¿Hay riesgo de ban sobre mi cuenta?",
      "answer2": "Tras nuestros años de experiencia, hemos desatrollado un método de traspaso junto a medidas que recomendamos seguir, para que tengas una transacción segura. Nuestra prioridad siempre es el cliente y la seguridad de su cuenta.",
      "faq3": "¿Qué métodos de pago ofrecéis?",
      "answer3": "Ofrecemos diversos métodos de pago para cada país, para que puedas pagar en tu moneda local. Para ver las opciones disponibles, puedes ver el inicio de nuestra página que allí aparecen la mayoría, o preguntándonos directamente en nuestro Whatsapp!",

      "faq4": "¿Esto es algo seguro?",
      "answer4" : "Vendemos monedas desde el FIFA 18. Tenemos +9000 ventas realizadas, y todos los años entregamos cerca de 1000 millones de monedas. Por si todavía desconfías, también puedes ver nuestras +7 historias destacadas de “Clientes” en nuestro Instagram, donde contamos con +15k de seguidores, y registramos solo algunas de nuestras ventas!",

      "faq5": "¿Vendéis también jugadores??",
      "answer5" : "Si pero no. No vendemos jugadores en sí, pero si vendemos la cantidad de monedas que te puede costar ese jugador que deseas o el SBC que quieras hacer. Es decir, puedes comprar monedas para luego con ellas, fichar ese jugador que buscas para tu plantilla.",

      "faq6": "¿Por qué las Monedas son mejores que los FIFA Points?",
      "answer6" : "Esto es algo sencillo. Son hasta 5 veces más baratas, y puedes hacer muchísimas más cosas que con los FIFA Points. Con estos, únicamente puedes abrir packs, por lo que dependes de la suerte que tengas en ellos. Con las monedas, puedes directamente comprar los jugadores que quieres, abrir packs, o destinarlas libremente a lo que quieras. Con el mismo dinero que te gastas en los FC Points, puedes abrir el triple de packs con las monedas.",

      "faq7": "¿En cuánto tiempo recibo mis monedas?",
      "answer7" : "Sencillo! Únicamente durará el tiempo de la puja. Una vez que realizas la compra, en 1 hora ya te llegan las monedas a tu cuenta.",

      "faq8": "¿Cubren el EA Tax y las monedas que gaste en el traspaso?",
      "answer8" : "Claro! Queremos que la cantidad de monedas que compres, sean la cantidad que te lleguen (muchas veces con regalito incluído 😉) Cubrimos el 5% del EA Tax y las monedas que gastes en la carta utilizada en el traspaso, por lo que si compras 100.000 monedas, te llegaran 100.000 monedas a tu cuenta. No perderás ni una moneda!",

      "faq9": "¿Debo tener monedas para comenzar con el traspaso?",
      "answer9" : "No es necesario contar con monedas para comenzar con el traspaso, utilizaremos cartas muy baratas o mismas que tengas en el club.",

      "faq10": "¿Tengo que brindarles los datos de mi cuenta o algun dato personal?",
      "answer10": "No, nunca te solicitaremos ningún tipo de dato personal tuyo o de tu cuenta.",

      "faq11": "No estoy con la consola, ¿puedo hacerlo desde la app companion?",
      "answer11" : "Si, puedes realizar el traspaso desde la App Companion de forma segura y sin complicaciones. Puedes hacerlo estés donde estés.",

      "faq12": "¿De qué se trata el servicio de FUT Boosting? ¿Es seguro?",
      "answer12" : "Si, el cliente SIEMPRE es nuestra prioridad. Contamos con jugadores profesionales y de confianza desde hace años, donde mediante nuestro sistema tus datos NUNCA se compartirán y permanecerán seguros, donde una vez finalizado el servicio, se eliminará todo tipo de información de la cuenta del cliente, teniendo solo tú nuevamente acceso a la cuenta.",

      "faqTitle" : "Preguntas Frecuentes",
      "showMore": "Mostrar Más",
      "showLess" : "Mostrar Menos",
      "buy" : "Comprar",
      "sellCoinsTittle" : "Vender Monedas",
      "sellCoins" : "Para comenzar a vender tus monedas, por favor contactanos a través de WhatsApp.",
      "aboutUs" : "Sobre Nosotros",
      "reason1": "+9.000 ventas realizadas",
      "reason2": "+12 años de experiencia",
      "reason3": "+3.800 clientes satisfechos",
      "reason4": "+2600 millones de monedas entregadas",
      "paso" : "PASO"
  }
};

export const translate = (key, language) => {
  if (translations[language] && translations[language][key]) {
      return translations[language][key];
  }
  console.warn(`Translation missing for key "${key}" in language "${language}"`);
  return key;
};

export default translations;
